import React, { Component } from 'react';
// new lines from here
import { connect } from "react-redux";
import rotateAction from "../actions/rotateAction";
//// new lines to here
import logo from '../staticAssets/Logo.svg';
import '../css/ReduxDemo.css';

class ReduxDemo extends Component {
    render() {
        return (
            <div className="App">
                <header className="App-header">
                    <img
                        src={logo}
                        className={
                            "App-logo" +
                            (this.props.rotating ? "" : " App-logo-paused")
                        }
                        alt="logo"
                        onClick={
                            () => this.props.rotateAction(!this.props.rotating)
                        }
                    />
                    <p>
                        Edit <code>src/App.js</code> and save to reload.
                    </p>
                    <a
                        className="App-link"
                        href="https://reactjs.org"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Learn React
                    </a>
                </header>
            </div>
        );
    }
}
const mapStateToProps = state => ({
    ...state.rotateReducer
});
const mapDispatchToProps = dispatch => ({
    rotateAction: (payload) => dispatch(rotateAction(payload))
});
export default connect(mapStateToProps, mapDispatchToProps)(ReduxDemo);
